import React from "react";
import PropTypes from 'prop-types';
import ScopeTagSelection from './scope_tag_selection';
import ScopeLabelSelection from './scope_label_selection';
import ScopeSectionSelection from './scope_section_selection';
import ScopeCustomFieldSelection from './scope_custom_field_selection';

function TriggerSelection({ ruleType, updateScope, scope }) {
  if (ruleType.includes("Rule::Tag")) {
    return <ScopeTagSelection scope={scope} updateScope={updateScope} />;
  }
  if (ruleType.includes("Rule::Label")) {
    return <ScopeLabelSelection scope={scope} updateScope={updateScope} />;
  }
  if (ruleType.includes("Rule::Section")) {
    return <ScopeSectionSelection scope={scope} updateScope={updateScope} />;
  }
  if (ruleType.includes("Rule::CustomField")) {
    return <ScopeCustomFieldSelection scope={scope} updateScope={updateScope} />;
  }
}

TriggerSelection.propTypes = {
  ruleType: PropTypes.string.isRequired,
  updateScope: PropTypes.func.isRequired
};

export default TriggerSelection;
